module.exports = __webpack_public_path__ + "static/img/two_990gaodeng.7587179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/two_990gaodeng.jpg
// module id = i18n
// module chunks = 46